import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  
  // BehaviorSubject to control terms modal visibility
  private termsModalSubject = new BehaviorSubject<boolean>(false);
  public termsModal$ = this.termsModalSubject.asObservable();

  // BehaviorSubject to pass terms content
  private termsContentSubject = new BehaviorSubject<any>(null);
  public termsContent$ = this.termsContentSubject.asObservable();

  // BehaviorSubject to handle modal close and navigation
  private modalCloseActionSubject = new BehaviorSubject<any>(null);
  public modalCloseAction$ = this.modalCloseActionSubject.asObservable();

  constructor() { }

  // Method to open terms modal
  openTermsModal(termsContent: any) {
    this.termsContentSubject.next(termsContent);
    this.termsModalSubject.next(true);
  }

  // Method to close terms modal
  closeTermsModal() {
    this.termsModalSubject.next(false);
    this.termsContentSubject.next(null);
  }

  // Method to set close action (navigation info)
  setCloseAction(action: any) {
    this.modalCloseActionSubject.next(action);
  }

  // Method to get current modal state
  isTermsModalOpen(): boolean {
    return this.termsModalSubject.value;
  }

  // Method to set terms accepted status
  setTermsAccepted(accepted: boolean) {
    // This method can be used to track terms acceptance status
    // You can add additional logic here if needed
  }
}